/* ════════════════════════════════════════════════════════════════════
   js/cookie-consent.js — Cookie Consent banner (152-ФЗ + GDPR-style)
   Phase B / LEGAL-08 (LEGAL-BLOCK Orchestra, 2026-04-29).
   Phase B / LEGAL-OPEN (2026-05-10) — 2026 best practices upgrade:
     - 3rd category «Маркетинг» (placeholder, opt-in)
     - WCAG 2.2 AA: focus-visible, prefers-reduced-motion, contrast,
       aria-live announce, role=dialog/aria-modal=true (banner + modal)
     - Mobile <520px touch targets ≥44px (Apple HIG)
     - prefers-color-scheme adaptation via CSS vars
     - Modal «Принять все» equivalent button (parity with banner)
     - <details> cookie-lists per category (transparency)
     - JSON consent value `{necessary,analytics,marketing}` для audit
       (back-compat: legacy values 'all'|'analytics'|'necessary' читаются)
   LEGAL-CLEANUP 2.6 (2026-05-15) — Webvisor как ОТДЕЛЬНАЯ категория:
     - 4-я категория «Запись поведения (Webvisor)» — отдельный чекбокс
     - Правовое основание: ст. 9 152-ФЗ (ред. с 01.09.2025) — отдельное
       согласие на каждую цель обработки. Webvisor (запись мыши/кликов/
       скроллов/форм) ≠ обычная аналитика → требует отдельного opt-in.
     - Cookie scalar расширен: 'all' | 'analytics+webvisor' | 'analytics'
       | 'necessary'. Cookie `cookie_consent_cats` хранит JSON-структуру
       категорий для granular чтения yandex-metrika-cmp.js.
     - «Принять все» в banner = ВСЕ 4 категории (necessary+analytics+
       webvisor+marketing). Модалка «Настроить» позволяет webvisor=false
       при analytics=true (granular opt-in).

   UX-C (2026-08-02) — вид сведён к ПЛАНКЕ (владелец: «маленькой красивой
   просвечивающей планкой, где будет только Принять и всё, как у всех»,
   «и на телефоне и на компьютере»):
     - в планке ОДНА кнопка «Принять» + ссылка «Подробнее» → /policy.php#section-8
     - гранулярный выбор и отказ одним нажатием («Отклонить все») переехали
       в окно настроек; вход в него есть на каждой странице — ссылка
       «Управление cookies» в подвале (data-cookie-consent-open)
     - серверная логика отказа (`recordConsent('necessary', …)`) не тронута

   Поведение:
   - Если cookie `cookie_consent` отсутствует ИЛИ `cookie_consent_v` !==
     PDN_TEXT_VERSION → показать планку внизу
   - Сохраняет в cookie `cookie_consent=all|analytics+webvisor|analytics|
     necessary` (scalar для back-compat ЯМ-gate) + `cookie_consent_cats`
     JSON-категории + `cookie_consent_v` версия PDN_TEXT_VERSION
   - При выборе → dispatch CustomEvent `cookie-consent-granted`
   - ЯМ-CMP (yandex-metrika-cmp.js) слушает event и грузит счётчик
     только при cats.analytics=true, webvisor только при cats.webvisor=true

   Соответствует: ст. 9 152-ФЗ (информированное согласие на обработку),
   GDPR (по аналогии для будущей ЕС-аудитории), WCAG 2.2 AA.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var COOKIE_NAME = 'cookie_consent';
  var COOKIE_VERSION_NAME = 'cookie_consent_v';
  // LEGAL-CLEANUP 2.6 — JSON-категории для granular consent (webvisor отдельно).
  // Дублирует scalar value для CMP-чтения yandex-metrika-cmp.js + backend audit.
  var COOKIE_CATEGORIES_NAME = 'cookie_consent_cats';
  var COOKIE_DAYS = 365;
  // SSOT — версия читается из meta-тега, который рендерит header.php из PDN_TEXT_VERSION.
  // Fallback 'v1.0' для backward compatibility (если meta отсутствует — старый клиент).
  // Актуальная version на 2026-05-15: v1.3 (LEGAL-CLEANUP 1.7+2.6.fix добавлена webvisor masking).
  function getPolicyVersion() {
    try {
      var m = document.querySelector('meta[name="pdn-text-version"]');
      if (m && m.content) return String(m.content).trim();
    } catch (_) { /* noop */ }
    return 'v1.0';
  }
  var STORAGE_VERSION = getPolicyVersion();

  // ── COOKIE-2 (2026-06-18): бот-обход cookie-баннера ─────────────────────
  // Поисковые краулеры НЕ должны видеть cookie-карточку вообще: они получают
  // контент сразу для индексации (исторически — чтобы не видеть блокирующую
  // стену COOKIE-1; с COOKIE-3 карточка уже НЕблокирующая, но бот всё равно
  // не нуждается в ней). Контент тот же что и для людей (карточка JS-инжектится
  // поверх уже отрендеренного DOM) → НЕ клоакинг.
  // Краулер не даёт согласия → Метрика у него не грузится (consent-gated) — это ОК.
  // Регекс case-insensitive (i), якоря не нужны (substring-match по UA-строке),
  // без multiline-дыр — флаг 'm' НЕ ставим (ENG-1 #9). Точка в Mail\.RU экранирована.
  // ⛔ YandexMobileBot — ОТДЕЛЬНОЕ имя, подстрокой YandexBot его НЕ поймать: между
  //    Yandex и Bot стоит Mobile. Мобильный робот, который и судит «удобство
  //    для мобильных», получал планку и считал её частью первого экрана (замер
  //    18.09.2026, yandex-mobile 1.2, решение владельца). Обход — только показа
  //    планки: согласия за робота никто не пишет (init() выходит до recordConsent).
  var CRAWLER_UA_RE = /YandexBot|YandexMobileBot|YandexMetrika|YandexAccessibilityBot|YandexRenderResourcesBot|Googlebot|Google-InspectionTool|Mediapartners-Google|AdsBot-Google|bingbot|DuckDuckBot|Baiduspider|SputnikBot|Mail\.RU_Bot|ia_archiver/i;

  function isCrawlerUA(ua) {
    if (typeof ua !== 'string' || ua === '') return false;
    return CRAWLER_UA_RE.test(ua);
  }

  function readCookie(name) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i].trim();
        if (p.indexOf(name + '=') === 0) {
          return decodeURIComponent(p.substring(name.length + 1));
        }
      }
    } catch (_) { /* noop */ }
    return null;
  }

  function writeCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + days * 86400000);
      var secure = (location.protocol === 'https:') ? '; Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value)
        + '; expires=' + d.toUTCString()
        + '; path=/; SameSite=Lax' + secure;
    } catch (_) { /* noop */ }
  }

  function dispatchGranted(value, categories) {
    try {
      document.dispatchEvent(new CustomEvent('cookie-consent-granted', {
        detail: {
          value: value,
          categories: categories || null,
          version: STORAGE_VERSION,
          ts: Date.now()
        }
      }));
    } catch (_) { /* fallback IE — не нужен */ }
  }

  function announce(msg) {
    // WCAG 2.2 AA — aria-live announce для screen readers.
    try {
      var live = document.getElementById('cookie-consent-live');
      if (!live) {
        live = document.createElement('div');
        live.id = 'cookie-consent-live';
        live.setAttribute('role', 'status');
        live.setAttribute('aria-live', 'polite');
        live.setAttribute('aria-atomic', 'true');
        live.style.cssText = 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden';
        document.body.appendChild(live);
      }
      // Очистить и записать заново — некоторые SR не объявляют повторный одинаковый текст.
      live.textContent = '';
      setTimeout(function () { live.textContent = msg; }, 50);
    } catch (_) { /* noop */ }
  }

  function recordConsent(value, categories) {
    if (_recording) return; // race-protection: повторный клик игнорируется
    _recording = true;
    writeCookie(COOKIE_NAME, value, COOKIE_DAYS);
    // Phase C.1: версия записывается в отдельный cookie для re-prompt при bump'е политики
    writeCookie(COOKIE_VERSION_NAME, STORAGE_VERSION, COOKIE_DAYS);
    // LEGAL-CLEANUP 2.6 — granular JSON для CMP-gate (webvisor отдельно).
    if (categories && typeof categories === 'object') {
      try {
        var compactCats = {
          necessary: true,
          analytics: !!categories.analytics,
          webvisor: !!categories.webvisor,
          marketing: !!categories.marketing
        };
        writeCookie(COOKIE_CATEGORIES_NAME, JSON.stringify(compactCats), COOKIE_DAYS);
      } catch (_) { /* noop: scalar value достаточно для legacy gate */ }
    }
    dispatchGranted(value, categories);
    announce('Настройки cookies сохранены: ' + value);
    // Audit на сервер (опционально — не блокирует UX если 4xx/5xx)
    try {
      var fd = new FormData();
      fd.append('value', value);
      fd.append('version', STORAGE_VERSION);
      if (categories && typeof categories === 'object') {
        fd.append('categories', JSON.stringify(categories));
      }
      // LEGAL-OPEN B.b (2026-05-10) — CSRF token из <meta name="csrf-token">
      // (header.php генерит через csrfToken()). Защита от XSS-driven same-origin POST flood.
      try {
        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        var csrfTok = csrfMeta && csrfMeta.content ? String(csrfMeta.content) : '';
        if (csrfTok) fd.append('_csrf', csrfTok);
      } catch (_) { /* noop */ }
      fetch('/api/consent-log.php', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        keepalive: true
      }).catch(function () { /* silent */ });
    } catch (_) { /* noop */ }
  }

  function buildBanner() {
    // UX-C (2026-08-02): планка вместо карточки. Владелец: «сделай куки маленькой
    // красивой просвечивающей планкой, где будет только Принять и всё, как у всех»,
    // уточнение — «и на телефоне и на компьютере». Один адаптивный компонент на обе
    // ширины: строка текста + ссылка «Подробнее» + одна кнопка «Принять».
    //
    // Что убрано из ПЛАНКИ и почему это безопасно юридически:
    //   • аккордеон «Подробнее ▼» с двумя абзацами — текст никуда не делся, он в
    //     /policy.php (раздел 8), куда ведёт ссылка прямо из планки. Требование
    //     информированности (152-ФЗ ст. 9 ч. 1) закрыто ссылкой, а не пересказом.
    //   • кнопка «Только обязательные» — гранулярный отказ остаётся полностью рабочим:
    //     recordConsent('necessary', …) не тронут, модалка настроек с 4 категориями
    //     на месте, вход в неё есть на КАЖДОЙ странице (футер «Управление cookies»,
    //     data-cookie-consent-open) и в самой Политике («открыть настройки» +
    //     «Отозвать согласие»). 152-ФЗ, в отличие от GDPR, не требует симметричной
    //     кнопки отказа в баннере — требует информированность и возможность отзыва.
    //     ⚠️ Если появится аудитория ЕС — вернуть парную кнопку отказа (GDPR).
    var wrap = document.createElement('div');
    wrap.id = 'cookie-consent-banner';
    wrap.className = 'cookie-consent-wrap';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-labelledby', 'cookie-consent-banner-desc');
    wrap.setAttribute('aria-describedby', 'cookie-consent-banner-desc');
    // COOKIE-3 (2026-06-18): откат блокировки COOKIE-1 — баннер теперь
    // НЕблокирующая угловая карточка (как у TrendAgent): без оверлея, без
    // scroll-lock, сайтом можно пользоваться. aria-modal=false — это НЕ модал,
    // фон доступен SR. Карточка висит в углу до явного выбора (152-ФЗ ст. 9 —
    // нужно явное действие, но без блокировки страницы).
    wrap.setAttribute('aria-modal', 'false');

    var inner = document.createElement('div');
    inner.className = 'cookie-consent-inner';

    // ── Top row: msg + Подробнее toggle + actions ───────────────
    var row = document.createElement('div');
    row.className = 'cookie-consent-row';

    var msg = document.createElement('p');
    msg.id = 'cookie-consent-banner-desc';
    msg.className = 'cookie-consent-msg';
    msg.textContent = 'Используем cookie и Яндекс Метрику для аналитики. ';

    // ⛔ ЮР-ИНВАРИАНТ: ссылка на Политику обязана присутствовать в планке —
    // это и есть «информированность» согласия (152-ФЗ ст. 9 ч. 1). Убирать нельзя
    // даже ради минимализма. Пины: tests/JS/cookie-consent-ui-polish.test.js +
    // tests/JS/cookie-consent-blocking.test.js + tests/Integration/legal-cookie-consent.test.mjs.
    // Ведём сразу в раздел 8 Политики — там именно про cookie. Раньше туда вела
    // ссылка из раскрывающегося блока; блок убран, ссылка сохранена.
    // ⚠️ ДОЛГ (найдено на гейте UX-C, дефект ДОСТАЛСЯ ПО НАСЛЕДСТВУ от старой
    // разметки): в app/templates/pages/policy_content.php у заголовка
    // «8. Использование cookies» НЕТ id="section-8" (там есть только id="section-6"),
    // поэтому якорь не срабатывает и пользователь попадает в начало Политики.
    // Страница открывается и информированность соблюдена, но доскроллить до
    // раздела про cookie приходится руками. Чинится одной строкой в policy_content.php,
    // ОДНАКО этот файл под pre-commit-хуком pdn-version-bump: правка потребует
    // либо bump PDN_TEXT_VERSION (= повторный запрос согласия у ВСЕХ посетителей),
    // либо обоснованного bypass. Оба варианта — решение владельца, не этого блока.
    var policyLink = document.createElement('a');
    policyLink.href = '/policy.php#section-8';
    policyLink.target = '_blank';
    policyLink.rel = 'noopener';
    policyLink.className = 'cookie-consent-link cookie-consent-policy-link';
    policyLink.textContent = 'Подробнее';
    msg.appendChild(policyLink);

    row.appendChild(msg);

    var actions = document.createElement('div');
    actions.className = 'cookie-consent-actions';

    // Одна кнопка. Набор категорий тот же, что раньше давала «Принять все», —
    // семантика согласия НЕ менялась, поменялся только вид планки.
    var btnAccept = document.createElement('button');
    btnAccept.type = 'button';
    btnAccept.className = 'cookie-consent-btn cookie-consent-btn-primary';
    btnAccept.textContent = 'Принять';
    btnAccept.addEventListener('click', function () {
      recordConsent('all', { necessary: true, analytics: true, webvisor: true, marketing: true });
      hideBanner();
    });
    actions.appendChild(btnAccept);

    row.appendChild(actions);
    inner.appendChild(row);

    wrap.appendChild(inner);
    return wrap;
  }

  // Phase A.5.1 — M2-style explanatory modal (открывается из banner «Подробнее»).
  // Текст по образцу M2.ru — explicit разъяснение что значат обе кнопки + ст. 9 152-ФЗ.
  function buildPolicyModal() {
    var modal = document.createElement('div');
    modal.id = 'cookie-consent-policy-modal';
    modal.className = 'cookie-consent-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cookie-consent-policy-modal-title');
    modal.setAttribute('aria-describedby', 'cookie-consent-policy-modal-desc');

    var box = document.createElement('div');
    box.className = 'cookie-consent-modal-box';

    var title = document.createElement('h3');
    title.id = 'cookie-consent-policy-modal-title';
    title.className = 'cookie-consent-modal-title';
    title.textContent = 'Использование файлов cookie';
    box.appendChild(title);

    var desc = document.createElement('div');
    desc.id = 'cookie-consent-policy-modal-desc';
    desc.className = 'cookie-consent-modal-desc';

    var p1 = document.createElement('p');
    p1.appendChild(document.createTextNode('Нажимая '));
    var s1a = document.createElement('strong');
    s1a.textContent = '«Принять все»';
    p1.appendChild(s1a);
    p1.appendChild(document.createTextNode(' вы даёте согласие на обработку cookie-файлов (подробнее в '));
    var policyLink = document.createElement('a');
    policyLink.href = '/policy.php';
    policyLink.target = '_blank';
    policyLink.rel = 'noopener';
    policyLink.className = 'cookie-consent-link';
    policyLink.textContent = 'Политике';
    p1.appendChild(policyLink);
    p1.appendChild(document.createTextNode('). БРОНИДОМ обрабатывает cookie, в том числе через сервисы веб-аналитики Яндекс Метрика, с целью обеспечения функционирования сайта, аналитики действий на сайте и улучшения качества обслуживания.'));
    desc.appendChild(p1);

    var p2 = document.createElement('p');
    p2.appendChild(document.createTextNode('Нажимая '));
    var s2a = document.createElement('strong');
    s2a.textContent = '«Отклонить все»';
    p2.appendChild(s2a);
    p2.appendChild(document.createTextNode(' или продолжая использовать сайт, БРОНИДОМ будет обрабатывать только функциональные cookie-файлы, необходимые для работы сайта. Чтобы отказаться от использования cookie-файлов (в том числе функциональных), вам следует прекратить использовать сайт.'));
    desc.appendChild(p2);

    box.appendChild(desc);

    var modalActions = document.createElement('div');
    modalActions.className = 'cookie-consent-modal-actions';

    var rejectAll = document.createElement('button');
    rejectAll.type = 'button';
    rejectAll.className = 'cookie-consent-btn cookie-consent-btn-secondary';
    rejectAll.textContent = 'Отклонить все';
    rejectAll.addEventListener('click', function () {
      recordConsent('necessary', { necessary: true, analytics: false, webvisor: false, marketing: false });
      closePolicyModal();
      hideBanner();
    });
    modalActions.appendChild(rejectAll);

    var acceptAll = document.createElement('button');
    acceptAll.type = 'button';
    acceptAll.className = 'cookie-consent-btn cookie-consent-btn-primary';
    acceptAll.textContent = 'Принять все';
    acceptAll.addEventListener('click', function () {
      recordConsent('all', { necessary: true, analytics: true, webvisor: true, marketing: true });
      closePolicyModal();
      hideBanner();
    });
    modalActions.appendChild(acceptAll);

    box.appendChild(modalActions);
    modal.appendChild(box);
    return modal;
  }

  var _policyModalEl = null;
  var _policyModalPrevFocus = null;
  function openPolicyModal() {
    if (_policyModalEl) return;
    _policyModalPrevFocus = document.activeElement;
    _policyModalEl = buildPolicyModal();
    document.body.appendChild(_policyModalEl);
    _policyModalEl.addEventListener('click', function (ev) {
      if (ev.target === _policyModalEl) closePolicyModal();
    });
    // ESC close
    var keyHandler = function (ev) {
      if (ev.key === 'Escape') {
        closePolicyModal();
        document.removeEventListener('keydown', keyHandler);
      }
    };
    document.addEventListener('keydown', keyHandler);
    // Focus first button
    var firstBtn = _policyModalEl.querySelector('button');
    if (firstBtn && typeof firstBtn.focus === 'function') firstBtn.focus();
    announce('Открыто окно с информацией о cookies. Выберите Принять все или Отклонить все. Esc для закрытия.');
  }
  function closePolicyModal() {
    if (_policyModalEl && _policyModalEl.parentNode) {
      _policyModalEl.parentNode.removeChild(_policyModalEl);
    }
    _policyModalEl = null;
    if (_policyModalPrevFocus && typeof _policyModalPrevFocus.focus === 'function') {
      try { _policyModalPrevFocus.focus(); } catch (_) { /* noop */ }
    }
    _policyModalPrevFocus = null;
  }

  function buildSettingsModal() {
    var modal = document.createElement('div');
    modal.id = 'cookie-consent-settings';
    modal.className = 'cookie-consent-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cookie-consent-settings-title');
    modal.setAttribute('aria-describedby', 'cookie-consent-settings-desc');

    var box = document.createElement('div');
    box.className = 'cookie-consent-modal-box';

    var title = document.createElement('h3');
    title.id = 'cookie-consent-settings-title';
    title.className = 'cookie-consent-modal-title';
    title.textContent = 'Настройки cookies';
    box.appendChild(title);

    var desc = document.createElement('p');
    desc.id = 'cookie-consent-settings-desc';
    desc.className = 'cookie-consent-modal-desc';
    desc.textContent = 'Выберите какие категории cookies разрешить. Необходимые включены всегда — без них сайт не работает.';
    box.appendChild(desc);

    // 2026 best practices: 4 категории + список cookies в <details>.
    // LEGAL-CLEANUP 2.6 — Webvisor выделен из «Аналитика» в отдельную категорию
    // по требованию ст. 9 152-ФЗ (отдельное согласие на каждую цель обработки).
    var groups = [
      {
        key: 'necessary',
        label: 'Необходимые',
        desc: 'Сессия, CSRF-токен, выбор города, ваш выбор cookies. Сайт не работает без них.',
        forced: true,
        cookies: [
          { name: 'PHPSESSID', purpose: 'Идентификатор сессии (до закрытия браузера)' },
          { name: 'csrf_token', purpose: 'Защита форм от CSRF-атак (1 час)' },
          { name: 'cookie_consent', purpose: 'Ваш выбор согласия (365 дней)' },
          { name: 'cookie_consent_v', purpose: 'Версия политики при согласии (365 дней)' },
          { name: 'cookie_consent_cats', purpose: 'Granular выбор категорий — JSON (365 дней)' }
        ]
      },
      {
        key: 'analytics',
        label: 'Аналитика',
        desc: 'Яндекс.Метрика — анализ посещаемости сайта (страницы, переходы, источники). Без записи действий. Только при вашем согласии.',
        forced: false,
        cookies: [
          { name: '_ym_uid', purpose: 'Идентификатор посетителя Яндекс.Метрики' },
          { name: '_ym_d', purpose: 'Дата первого визита' },
          { name: '_ym_isad', purpose: 'Признак блокировщика рекламы' }
        ]
      },
      {
        key: 'webvisor',
        label: 'Запись поведения (Webvisor)',
        desc: 'Детальная запись действий: движения мыши, клики, скроллы, заполнение форм (значения полей НЕ передаются, только факт ввода). Используется для улучшения интерфейса. Включается ОТДЕЛЬНО от аналитики (ст. 9 152-ФЗ — отдельное согласие на каждую цель обработки).',
        forced: false,
        cookies: [
          { name: '_ym_visorc', purpose: 'Идентификатор сессии Webvisor (запись действий)' }
        ]
      },
      {
        key: 'marketing',
        label: 'Маркетинг',
        desc: 'Будут добавлены при запуске рекламных кампаний (Yandex.Direct ERID). Сейчас не используются.',
        forced: false,
        cookies: []
      }
    ];

    var checkboxes = {};
    groups.forEach(function (g) {
      var section = document.createElement('div');
      section.className = 'cookie-consent-modal-row';

      var row = document.createElement('label');
      row.className = 'cookie-consent-modal-rowhead';

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.name = 'consent-' + g.key;
      cb.id = 'consent-' + g.key;
      cb.checked = g.forced;
      if (g.forced) cb.disabled = true;
      cb.setAttribute('data-category', g.key);
      checkboxes[g.key] = cb;
      row.appendChild(cb);

      var lbl = document.createElement('span');
      lbl.className = 'cookie-consent-modal-label';
      lbl.textContent = g.label;
      if (g.forced) {
        var forcedBadge = document.createElement('span');
        forcedBadge.className = 'cookie-consent-modal-forced';
        forcedBadge.textContent = ' (всегда вкл)';
        lbl.appendChild(forcedBadge);
      }
      row.appendChild(lbl);

      section.appendChild(row);

      var d = document.createElement('p');
      d.className = 'cookie-consent-modal-rowdesc';
      d.textContent = g.desc;
      section.appendChild(d);

      // Cookie list expander (transparency requirement)
      if (g.cookies && g.cookies.length) {
        var details = document.createElement('details');
        details.className = 'cookie-consent-modal-details';
        var summary = document.createElement('summary');
        summary.textContent = 'Список cookies (' + g.cookies.length + ')';
        details.appendChild(summary);
        var ul = document.createElement('ul');
        ul.className = 'cookie-consent-modal-cookielist';
        g.cookies.forEach(function (c) {
          var li = document.createElement('li');
          var code = document.createElement('code');
          code.textContent = c.name;
          li.appendChild(code);
          li.appendChild(document.createTextNode(' — ' + c.purpose));
          ul.appendChild(li);
        });
        details.appendChild(ul);
        section.appendChild(details);
      }

      box.appendChild(section);
    });

    var modalActions = document.createElement('div');
    modalActions.className = 'cookie-consent-modal-actions';

    var saveBtn = document.createElement('button');
    saveBtn.type = 'button';
    saveBtn.className = 'cookie-consent-btn cookie-consent-btn-primary';
    saveBtn.textContent = 'Сохранить выбор';
    saveBtn.addEventListener('click', function () {
      var cats = {
        necessary: true,
        analytics: !!(checkboxes.analytics && checkboxes.analytics.checked),
        webvisor: !!(checkboxes.webvisor && checkboxes.webvisor.checked),
        marketing: !!(checkboxes.marketing && checkboxes.marketing.checked)
      };
      // Guard: webvisor требует analytics (нельзя записать поведение без счётчика).
      // UI-инвариант — webvisor checkbox disabled когда analytics unchecked
      // (см. wire ниже). Здесь backend-side enforce на случай race conditions.
      if (cats.webvisor && !cats.analytics) {
        cats.webvisor = false;
      }
      // Scalar value для back-compat ЯМ-gate в header.php + backend whitelist
      // в api/consent-log.php (LEGAL-CLEANUP 2.6 расширил: + 'analytics+webvisor').
      var value;
      if (cats.analytics && cats.webvisor && cats.marketing) value = 'all';
      else if (cats.analytics && cats.webvisor) value = 'analytics+webvisor';
      else if (cats.analytics) value = 'analytics';
      else value = 'necessary';
      recordConsent(value, cats);
      hideSettings();
      hideBanner();
    });
    modalActions.appendChild(saveBtn);

    // Wire: webvisor checkbox disabled когда analytics unchecked.
    // Юр-логика: запись поведения подразумевает что обычная аналитика тоже включена
    // (Я.Метрика не позволяет webvisor без основного счётчика).
    function syncWebvisorEnabled() {
      if (!checkboxes.webvisor || !checkboxes.analytics) return;
      if (!checkboxes.analytics.checked) {
        checkboxes.webvisor.checked = false;
        checkboxes.webvisor.disabled = true;
      } else {
        checkboxes.webvisor.disabled = false;
      }
    }
    if (checkboxes.analytics) {
      checkboxes.analytics.addEventListener('change', syncWebvisorEnabled);
    }
    syncWebvisorEnabled();

    var acceptAllBtn = document.createElement('button');
    acceptAllBtn.type = 'button';
    acceptAllBtn.className = 'cookie-consent-btn cookie-consent-btn-secondary';
    acceptAllBtn.textContent = 'Принять все';
    acceptAllBtn.addEventListener('click', function () {
      recordConsent('all', { necessary: true, analytics: true, webvisor: true, marketing: true });
      hideSettings();
      hideBanner();
    });
    modalActions.appendChild(acceptAllBtn);

    // UX-C (2026-08-02): отказ в ОДНО нажатие. Раньше он жил кнопкой «Только
    // обязательные» на самой планке; планку свели к одной кнопке «Принять», и чтобы
    // отказаться, пришлось бы снимать четыре галочки вручную — это уже не
    // «возможность отказаться», а квест. Кнопка возвращает отказ одним нажатием,
    // и вход в это окно есть на каждой странице (подвал, «Управление cookies»).
    var rejectAllBtn = document.createElement('button');
    rejectAllBtn.type = 'button';
    rejectAllBtn.className = 'cookie-consent-btn cookie-consent-btn-secondary';
    rejectAllBtn.textContent = 'Отклонить все';
    rejectAllBtn.addEventListener('click', function () {
      recordConsent('necessary', { necessary: true, analytics: false, webvisor: false, marketing: false });
      hideSettings();
      hideBanner();
    });
    modalActions.appendChild(rejectAllBtn);

    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'cookie-consent-btn cookie-consent-btn-link';
    cancelBtn.textContent = 'Отмена';
    cancelBtn.addEventListener('click', hideSettings);
    modalActions.appendChild(cancelBtn);

    box.appendChild(modalActions);

    // Policy link (full transparency)
    var policyP = document.createElement('p');
    policyP.className = 'cookie-consent-modal-policy';
    var policyA = document.createElement('a');
    policyA.href = '/policy.php';
    policyA.target = '_blank';
    policyA.rel = 'noopener';
    policyA.textContent = 'Подробнее в Политике конфиденциальности';
    policyP.appendChild(policyA);
    box.appendChild(policyP);

    modal.appendChild(box);
    return modal;
  }

  var _bannerEl = null;
  var _settingsEl = null;
  var _settingsKeydownHandler = null;
  var _settingsPrevFocus = null;
  var _recording = false; // race-protection: один клик = одна запись
  var _autohideTimer = null; // Phase A.2: auto-hide через 30 сек если не было interaction

  // ── COOKIE-3 (2026-06-18): НЕблокирующая угловая карточка ───────────────
  // Откат COOKIE-1: оверлей + scroll-lock + focus-trap + Esc-block УБРАНЫ.
  // Карточка висит в углу (см. CSS .cookie-consent-wrap), сайтом можно
  // пользоваться (листать/кликать). Фокус мягко уводится на первую кнопку,
  // но без trap — Tab свободно выходит из карточки в контент страницы.
  var _bannerPrevFocus = null;

  // Phase A.2 (2026-05-22): auto-hide timeout.
  // Если юзер не выбрал ничего за 30 сек — банер исчезает с fadeOut animation,
  // НО cookie НЕ записывается → банер появится снова в следующей сессии (152-ФЗ ст. 9
  // — информированное согласие требует явного действия; пассивное игнорирование ≠ согласие).
  var AUTOHIDE_MS = 30000;

  function startAutohide() {
    clearAutohide();
    _autohideTimer = setTimeout(function () {
      fadeOutBanner();
    }, AUTOHIDE_MS);
    // Node.js test runner DX: timer.unref() позволяет process exit когда
    // только этот long-lived timer holding event loop. В браузере unref() нет —
    // typeof guard защищает. Без unref test держит process 30 сек после
    // прохождения 14 tests (см. cookie-consent-init.test.js).
    if (_autohideTimer && typeof _autohideTimer.unref === 'function') {
      _autohideTimer.unref();
    }
  }

  function clearAutohide() {
    if (_autohideTimer) {
      clearTimeout(_autohideTimer);
      _autohideTimer = null;
    }
  }

  function fadeOutBanner() {
    // Defensive: при поздних timer fires (после DOM teardown / SPA navigate /
    // vm sandbox dispose в тестах) _bannerEl может быть partial / lacking classList.
    // Без guard test runner крашится uncaughtException когда 30s autohide fires
    // после end-of-test (cookie-consent-init.test.js JSDOM-light mock без classList).
    if (!_bannerEl || !_bannerEl.classList || typeof _bannerEl.classList.add !== 'function') return;
    _bannerEl.classList.add('cookie-consent-fadeout');
    // 300мс = matches CSS @keyframes cookieConsentFadeOut .3s
    setTimeout(function () {
      hideBanner();
    }, 320);
  }

  function showBanner() {
    if (_bannerEl) return;
    // COOKIE-3 (2026-06-18): НЕблокирующая угловая карточка — без оверлея,
    // без scroll-lock. Сайтом можно пользоваться, карточка висит в углу.
    _bannerPrevFocus = document.activeElement;
    _bannerEl = buildBanner();
    document.body.appendChild(_bannerEl);
    announce('Мы используем файлы cookie. Доступны действия: принять файлы cookie, открыть Политику обработки данных. Настроить категории по отдельности можно по ссылке «Управление cookies» в подвале сайта.');

    // COOKIE-3: фокус мягко уводится на первую кнопку (UX/доступность), НО без
    // focus-trap и без Esc-block — Tab свободно выходит в контент страницы.
    // Auto-hide НЕ запускается: карточка висит до явного выбора (152-ФЗ ст. 9 —
    // пассивное игнорирование ≠ согласие; иначе Метрика не включится). Не
    // блокирует — просто не исчезает сама.
    // UX-C: фокус ставим на «Принять», а не на первый по DOM элемент. В планке первой
    // идёт ссылка «Подробнее», и фокус на ней и выглядел странно (обводка на ссылке),
    // и уводил от главного действия. Ищем перебором, а НЕ querySelector: в моках
    // tests/JS/cookie-consent-init.test.js у элементов есть querySelectorAll, но нет
    // querySelector — вызов уронил бы все 14 тестов инициализации.
    try {
      var f = getFocusable(_bannerEl);
      var target = null;
      for (var i = 0; i < f.length; i++) {
        var cls = f[i] && f[i].className ? String(f[i].className) : '';
        if (cls.indexOf('cookie-consent-btn-primary') !== -1) { target = f[i]; break; }
      }
      if (!target && f.length) target = f[0];
      if (target && typeof target.focus === 'function') target.focus();
    } catch (_) { /* noop */ }
  }

  function hideBanner() {
    clearAutohide();
    // COOKIE-3: блокировки нет — просто убрать карточку + вернуть фокус.
    if (_bannerEl && _bannerEl.parentNode) {
      _bannerEl.parentNode.removeChild(_bannerEl);
    }
    _bannerEl = null;
    if (_bannerPrevFocus && typeof _bannerPrevFocus.focus === 'function') {
      try { _bannerPrevFocus.focus(); } catch (_) { /* noop */ }
    }
    _bannerPrevFocus = null;
  }

  function getFocusable(root) {
    if (!root) return [];
    var sel = 'button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"]),a[href],summary,details';
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function settingsKeydown(ev) {
    if (!_settingsEl) return;
    if (ev.key === 'Escape' || ev.keyCode === 27) {
      ev.preventDefault();
      hideSettings();
      return;
    }
    if (ev.key === 'Tab' || ev.keyCode === 9) {
      var focusables = getFocusable(_settingsEl);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (ev.shiftKey && document.activeElement === first) {
        ev.preventDefault();
        last.focus();
      } else if (!ev.shiftKey && document.activeElement === last) {
        ev.preventDefault();
        first.focus();
      }
    }
  }

  function openSettings() {
    if (_settingsEl) return;
    _settingsPrevFocus = document.activeElement;
    _settingsEl = buildSettingsModal();
    document.body.appendChild(_settingsEl);
    // Backdrop click → close
    _settingsEl.addEventListener('click', function (ev) {
      if (ev.target === _settingsEl) hideSettings();
    });
    // Focus trap + Esc handler
    _settingsKeydownHandler = settingsKeydown;
    document.addEventListener('keydown', _settingsKeydownHandler);
    // Initial focus → first focusable
    var f = getFocusable(_settingsEl);
    if (f.length) f[0].focus();
    announce('Открыто окно настроек cookies. Выберите категории и нажмите Сохранить выбор. Esc для отмены.');
  }

  function hideSettings() {
    if (_settingsEl && _settingsEl.parentNode) {
      _settingsEl.parentNode.removeChild(_settingsEl);
    }
    _settingsEl = null;
    if (_settingsKeydownHandler) {
      document.removeEventListener('keydown', _settingsKeydownHandler);
      _settingsKeydownHandler = null;
    }
    if (_settingsPrevFocus && typeof _settingsPrevFocus.focus === 'function') {
      try { _settingsPrevFocus.focus(); } catch (_) { /* noop */ }
    }
    _settingsPrevFocus = null;
  }

  function init() {
    // COOKIE-2 (2026-06-18): бот-обход. Поисковый краулер НЕ получает
    // блокирующий баннер (ни оверлей, ни scroll-lock) — индексирует чистый
    // контент. Метрика у бота и так не грузится (consent-gated в CMP). Контент
    // тот же что и для людей → не клоакинг (баннер — overlay, не подмена DOM).
    var _ua = '';
    try {
      _ua = (typeof navigator !== 'undefined' && navigator && navigator.userAgent)
        ? String(navigator.userAgent) : '';
    } catch (_) { _ua = ''; }
    if (isCrawlerUA(_ua)) {
      return;
    }
    var consent = readCookie(COOKIE_NAME);
    var consentVersion = readCookie(COOKIE_VERSION_NAME);
    // LEGAL-CLEANUP 2.6 — расширен whitelist scalar value: добавлен
    // 'analytics+webvisor' (analytics+webvisor opt-in без marketing).
    // 'all' теперь подразумевает necessary+analytics+webvisor+marketing.
    var validValue = (
      consent === 'all' ||
      consent === 'analytics+webvisor' ||
      consent === 'analytics' ||
      consent === 'necessary'
    );
    // Phase B (LEGAL-OPEN) — strict-equal version sync (P2 carry-over from Block A coverage).
    // === enforces type + value identity. Если cookie_consent_v отсутствует (null) →
    // versionMatch=false → re-prompt (legacy clients pre-v1.1 без version cookie).
    var versionMatch = (consentVersion === STORAGE_VERSION);
    // Phase C.1: re-prompt при существенном изменении политики (152-ФЗ ст. 9 ч. 1).
    // Если версия cookie не совпадает с актуальной → показать banner повторно.
    if (validValue && versionMatch) {
      // Согласие актуальной версии — banner не показываем, но событие дёрнем
      // повторно для load-after-navigate сценария.
      // ЯМ-CMP (yandex-metrika-cmp.js) подхватит granted и загрузит счётчик.
      if (consent === 'all' || consent === 'analytics+webvisor' || consent === 'analytics') {
        // Restore categories из JSON-cookie (LEGAL-CLEANUP 2.6) для CMP.
        var catsRaw = readCookie(COOKIE_CATEGORIES_NAME);
        var cats = null;
        if (catsRaw) {
          try {
            var parsed = JSON.parse(catsRaw);
            if (parsed && typeof parsed === 'object') {
              cats = {
                necessary: true,
                analytics: !!parsed.analytics,
                webvisor: !!parsed.webvisor,
                marketing: !!parsed.marketing
              };
            }
          } catch (_) { /* fallthrough: cats=null, CMP derive из scalar */ }
        }
        dispatchGranted(consent, cats);
      }
      return;
    }
    // Нет cookie ИЛИ устарела версия → показываем banner.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showBanner, { once: true });
    } else {
      showBanner();
    }
  }

  // Public API — для повторного открытия настроек (например из футера-ссылки)
  window.CookieConsent = {
    open: function () { openSettings(); },
    reset: function () {
      writeCookie(COOKIE_NAME, '', -1); // expire
      writeCookie(COOKIE_VERSION_NAME, '', -1); // expire version cookie too
      writeCookie(COOKIE_CATEGORIES_NAME, '', -1); // LEGAL-CLEANUP 2.6 — expire JSON cats
      _recording = false;
      showBanner();
    },
    value: function () { return readCookie(COOKIE_NAME); },
    version: function () { return STORAGE_VERSION; },
    // COOKIE-2 — экспонируем helper для тестов/диагностики (не новый глобал).
    isCrawler: function (ua) { return isCrawlerUA(ua); }
  };

  // Делегирование data-cookie-consent-open / data-cookie-consent-reset
  // (для ссылок в policy.php / footer / других страниц).
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    while (t && t !== document) {
      if (t.hasAttribute && t.hasAttribute('data-cookie-consent-open')) {
        ev.preventDefault();
        openSettings();
        return;
      }
      if (t.hasAttribute && t.hasAttribute('data-cookie-consent-reset')) {
        ev.preventDefault();
        window.CookieConsent.reset();
        return;
      }
      t = t.parentNode;
    }
  });


  /* ════════════════════════════════════════════════════════════════════
     ПЛАНКА НЕ ЛОЖИТСЯ НА ЛИПКУЮ НИЖНЮЮ ПАНЕЛЬ (23.08.2026)

     ⛔ ПОЧЕМУ ЗАМЕР, А НЕ ЧИСЛО В CSS. В css/components.css подъём планки над
        липкой панелью зашит числом 72 и знает ровно про ОДНУ панель —
        `.jk-bottom-bar`. У карточки КВАРТИРЫ панель зовётся `.flat-bottom-bar`,
        в тот список её не внесли — и планка легла прямо на цену с кнопкой
        «Забронировать». Замер 375x667 до правки: планка y 601...667, панель
        y 598...667; семь проверок `elementFromPoint` по панели дали СЕМЬ
        попаданий в планку и НОЛЬ в панель.
        Плюс высота панели непостоянная: 69 точек с ценой в строку и 81 у брони.
        Поэтому меряем верх панели на живой странице и поднимаем ровно настолько.

     ⛔ ТЕКСТ СОГЛАСИЯ, ССЫЛКУ НА ПОЛИТИКУ И ПОВЕДЕНИЕ КНОПКИ «ПРИНЯТЬ» ЭТОТ
        КУСОК НЕ ТРОГАЕТ — только положение планки и плавающих кружков. Значит
        PDN_TEXT_VERSION поднимать не нужно.
     ════════════════════════════════════════════════════════════════════ */
  (function () {
    var GAP = 8;                                    // зазор между планкой и панелью
    var BARS = '.flat-bottom-bar, .jk-bottom-bar';  // липкие панели, прижатые к низу
    var FLOATERS = '#aiFab, .ai-fab, .messenger-widgets';

    /* ⛔ БЕЗ ПОЛНОГО ДОМА ЭТОТ КУСОК ПРОСТО НЕ ВКЛЮЧАЕТСЯ, И ЭТО НЕ ПЕРЕСТРАХОВКА.
       Первая редакция звала `document.querySelectorAll` сразу — и в песочницах
       тестов (облегчённый DOM без него) падала с TypeError. Падала ОНА, а уносила
       с собой ВЕСЬ файл: 65 проверок согласия покраснели разом, включая обход
       для поисковых роботов и запись согласия. То есть косметический помощник
       положения планки оказался способен снять механизм ИНФОРМИРОВАННОГО СОГЛАСИЯ
       (152-ФЗ, ст. 9 ч. 1) — а это не «некрасиво», это юридический риск.
       Планка обязана работать, даже если подъём посчитать нечем. */
    if (typeof document.querySelectorAll !== 'function'
      || typeof document.getElementById !== 'function'
      || typeof window.getComputedStyle !== 'function') {
      return;
    }

    function seen(el) {
      if (!el) return false;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    /* ⛔ ПИШЕМ ТОЛЬКО ТО, ЧТО ИЗМЕНИЛОСЬ — И ЭТО НЕ КОСМЕТИКА, А РАЗРЫВ ПЕТЛИ.

       Замер 24.08.2026 на стенде (карточка квартиры, замедление процессора x4):
            2,5 секунды БЕЗ ЕДИНОГО ДЕЙСТВИЯ — 386 пересчётов, 772 обхода
            документа, 374 мс только на поиск элементов
       Пересчёт кормил сам себя: applyLift писал `--ckb-lift` в style корня,
       наблюдатель за изменениями видел СВОЮ ЖЕ запись (он следил за атрибутом
       style у всего поддерева body) и звал пересчёт снова. Круг замыкался, и
       главный поток не простаивал никогда — отсюда и медленный отклик на
       нажатия: браузеру просто негде было их обработать.
       Запись, не меняющая значения, всё равно порождает изменение атрибута.
       Поэтому сверяемся с тем, что уже стоит, и молчим, если совпало. */
    function setVar(style, name, value) {
      if (value === null) {
        if (style.getPropertyValue(name) !== '') style.removeProperty(name);
        return;
      }
      if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
    }

    function applyLift() {
      var root = document.documentElement;
      var banner = document.getElementById('cookie-consent-banner');
      var vh = window.innerHeight;

      // ── 1. На сколько поднять планку ──────────────────────────────────
      // Берём ТОЛЬКО панели, реально прижатые к низу окна (допуск 4 точки):
      // иначе в расчёт попала бы панель, уехавшая за экран или спрятанная.
      var lift = 0;
      var bars = document.querySelectorAll(BARS);
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        if (!seen(bar)) continue;
        var r = bar.getBoundingClientRect();
        if (r.bottom < vh - 4) continue;
        lift = Math.max(lift, Math.round(vh - r.top));
      }
      if (lift > 0) setVar(root.style, '--ckb-lift', lift + 'px');
      else setVar(root.style, '--ckb-lift', null);

      // ── 2. Кружки — выше планки ───────────────────────────────────────
      var floaters = document.querySelectorAll(FLOATERS);
      var j;

      // Планки нет (согласие уже дано) — возвращаем кружки на своё место.
      if (!banner || !seen(banner)) {
        setVar(root.style, '--ckb-banner-h', null);
        for (j = 0; j < floaters.length; j++) {
          if (floaters[j].style.marginBottom !== '') floaters[j].style.marginBottom = '';
        }
        return;
      }

      // ⛔ ВЫСОТУ И ПОЛОЖЕНИЕ БЕРЁМ ИЗ РАСКЛАДКИ, А НЕ ИЗ getBoundingClientRect().
      //    Планка выезжает снизу анимацией translateY, и прямоугольник в момент
      //    выезда показывает её ЗА КРАЕМ ЭКРАНА. Первый заход поверил этому
      //    прямоугольнику — и поднял кружки на 2 точки вместо 59: золотой кружок
      //    чата сел прямо на кнопку «Принять» (проверка elementFromPoint в правом
      //    крае кнопки возвращала .ai-fab). offsetHeight и computed `bottom`
      //    сдвига не знают — они про раскладку, а не про анимацию.
      var bh = banner.offsetHeight;
      var bottomPx = parseFloat(getComputedStyle(banner).bottom) || 0;
      setVar(root.style, '--ckb-banner-h', Math.round(bh) + 'px');
      var topFromBottom = bottomPx + bh;   // сколько занимает планка снизу окна

      // ⛔ СОБСТВЕННЫЙ ОТСТУП КРУЖКА БЕРЁМ ИЗ CSS-СВОЙСТВА `bottom`, А НЕ ЗАМЕРОМ.
      //    Второй заход делал так: обнулял сдвиг и мерил, где кружок оказался.
      //    Но у кружков висит ПЛАВНЫЙ ПЕРЕХОД margin-bottom (0,35 с) — сразу после
      //    обнуления кружок ещё едет, и замер ловил его на полпути. Число выходило
      //    31 вместо 59, и кружок продолжал лежать на планке. Computed `bottom`
      //    перехода не знает: это то, к чему кружок привязан.
      // ⛔ СДВИГ ОДИН НА ВСЮ СТОПКУ, А НЕ У КАЖДОГО КРУЖКА СВОЙ (yandex-mobile 1.2,
      //    18.09.2026). Здесь было «каждому — ровно до верха планки»: кнопка ИИ
      //    (bottom 16) и столбик мессенджеров (bottom 84) поднимались к ОДНОЙ линии,
      //    и кнопка ИИ садилась на Telegram. Замер стенда: 375×667 — нахлёст 48×10,
      //    карточка ЖК — 48×26, iPhone SE — 19 точек. Правило в css/components.css
      //    («поднимать надо оба разом, одинаковый сдвиг сохраняет их взаимное
      //    расположение») эту редакцию и требовало. Сдвиг берём по САМОМУ НИЖНЕМУ
      //    кружку — он первым упирается в планку, остальные едут на столько же.
      var stack = [];
      var shift = 0;
      for (j = 0; j < floaters.length; j++) {
        var f = floaters[j];
        // A contact hidden over page content still belongs to the fixed stack.
        // Keep its offset ready when scrolling makes it visible again.
        if (!seen(f) && !f.classList.contains('widget-yielding')) continue;
        var cs = getComputedStyle(f);
        if (cs.position !== 'fixed') continue;   // не прижат к окну — не наш случай
        var own = parseFloat(cs.bottom);
        if (!isFinite(own)) continue;
        stack.push(f);
        shift = Math.max(shift, Math.round(topFromBottom + GAP - own));
      }
      var mb = shift + 'px';
      for (j = 0; j < stack.length; j++) {
        if (stack[j].style.marginBottom !== mb) stack[j].style.marginBottom = mb;   // см. setVar выше
      }
    }

    /* ⛔ ТРИ ПРОХОДА, А НЕ ОДИН, И ЭТО ЗАМЕР, А НЕ ПЕРЕСТРАХОВКА.

       Панель на компьютере показывает ЧУЖОЙ код (наблюдатель в js/flat.js: карточка
       сделки ушла из вида → классу панели добавляется `flat-bottom-visible`). Наши
       наблюдатели просыпаются от этого же изменения — но раскладка к моменту первого
       чтения ещё не всегда встала.

       Замер 1440x900, мгновенный прыжок на 2000 точек, с меткой-часовым в переменной:
            1490 мс — applyLift отработал и СНЯЛ подъём (панель мерилась ещё скрытой)
            2496 мс — applyLift отработал снова и поставил 69px
            итого   — целая секунда, когда планка лежит на панели
       То есть проходов было достаточно, а вот ПЕРВЫЙ приходил слишком рано. Отсюда
       не «добавить ещё одно событие» (поводов у чужого кода может быть сколько
       угодно), а перемерить ту же коробку ещё дважды: на следующем кадре и через
       четверть секунды, когда любое движение точно закончилось.

       Стоимость — два лишних чтения раскладки на событие; события уже сжаты
       до одного на кадр самим requestAnimationFrame. */
    // ⛔ Второй рубеж: даже если раскладка отдаст что-то неожиданное, положение
    //    планки не имеет права уронить согласие. Тихо пропускаем проход.
    var applyLiftSafe = function () {
      try { applyLift(); } catch (e) { /* положение — не повод ломать согласие */ }
    };

    /* ⛔ ОДИН КОМПЛЕКТ ПРОХОДОВ НА КАДР, СКОЛЬКО БЫ ПОВОДОВ НИ ПРИШЛО.

       Поводов пересчитать много и они приходят пачками: прокрутка, конец
       перехода, конец анимации, изменение размера, появление узлов. Раньше
       КАЖДЫЙ повод заводил свои три прохода, и они складывались.
       Замер 24.08.2026 (замедление x4): один клик по стрелке галереи давал
       152 пересчёта и 115 мс на обходы документа — при том, что нужен был один.
       Теперь пока комплект запланирован, новые поводы не заводят второй: они
       и так попадут в тот же кадр и увидят ту же самую раскладку. */
    var pending = false;
    var lateTimer = 0;
    var runLift = function () {
      if (typeof window.requestAnimationFrame !== 'function') { applyLiftSafe(); return; }
      // Поздний проход всегда один: перезапускаем таймер, а не копим таймеры.
      if (lateTimer) clearTimeout(lateTimer);
      lateTimer = setTimeout(function () { lateTimer = 0; applyLiftSafe(); }, 250);
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        applyLiftSafe();
        window.requestAnimationFrame(function () {
          pending = false;
          applyLiftSafe();
        });
      });
    };

    runLift();
    window.addEventListener('resize', runLift);
    window.addEventListener('orientationchange', runLift);
    /* ⛔ ПРОКРУТКА — ОБЯЗАТЕЛЬНОЕ СОБЫТИЕ, И ЭТО ЗАМЕР, А НЕ ПРЕДОСТОРОЖНОСТЬ.
       На телефоне липкая панель включена всегда, поэтому подъём считался один раз
       при загрузке и был верен. На КОМПЬЮТЕРЕ панель появляется только когда
       карточка сделки уходит из вида — то есть ПОСЛЕ прокрутки. Прокрутки в списке
       событий не было, подъём не пересчитывался, и планка ложилась прямо на панель.
       Замер 1440x900 после прокрутки на 2000 точек:
            панель  y 831...900
            планка  y 842...884  (ВНУТРИ панели)
            семь точек по панели — ЧЕТЫРЕ попадания, три ушли в текст планки
       Слушатель пассивный, а `runLift` завёрнут в requestAnimationFrame, поэтому
       частые события прокрутки не считают заново больше раза на кадр. */
    window.addEventListener('scroll', runLift, { passive: true });
    /* ⛔ ПЕРЕСЧЁТ ПОСЛЕ ЛЮБОГО ДВИЖЕНИЯ, А НЕ ТОЛЬКО ПОСЛЕ ВЫЕЗДА ПЛАНКИ.
       Здесь стояло `if (e.target.id === 'cookie-consent-banner')` — и ровно на этом
       черновик и спотыкался, а замер это показал числами.

       Замер 1440x900, мгновенный прыжок на 2000 точек:
            панель появилась     — 1096 мс
            подъём встал         — 2113 мс
            разрыв               — 1017 мс, целая секунда «планка лежит на панели»
       Причина: панель ВЫЕЗЖАЕТ. Пока она едет, её прямоугольник ещё ниже нижнего
       края окна, и `vh - r.top` выходит отрицательным — подъём считается нулевым
       и СНИМАЕТСЯ. Последний пересчёт приходился ровно на середину выезда, а
       конца этого выезда никто не слушал: фильтр по имени пропускал только
       планку cookie. Получалась картина «наблюдатели живы, событий много,
       а результат неверный» — самая обманчивая из возможных.

       Слушаем оба события у ЛЮБОГО элемента: движение закончилось — коробка
       встала на место, можно мерить. Слушатели пассивные и в фазе всплытия,
       на страницу это не влияет. */
    document.addEventListener('animationend', runLift, { passive: true });
    document.addEventListener('transitionend', runLift, { passive: true });
    /* Планка приходит не сразу и уходит после «Принять» — ловим оба события.
       ⛔ АТРИБУТЫ ТУТ ВАЖНЕЕ УЗЛОВ, И ЭТО ЗАМЕР. Наблюдатель следил только за
          появлением новых узлов (`childList`). Но липкая панель на компьютере
          лежит в DOM С САМОГО НАЧАЛА и лишь ПОКАЗЫВАЕТСЯ сменой класса, когда
          карточка сделки уходит из вида. Смены класса `childList` не видит.
          `attributeFilter` держит наблюдение узким: только класс и стиль. */
    // Сначала заводим наблюдателя за КОРОБКАМИ (см. длинное пояснение ниже) —
    // наблюдатель за появлением узлов будет отдавать ему новые панели.
    var ro = null;
    var watchBox = function (el) { if (ro && el) { try { ro.observe(el); } catch (e) { /* уже наблюдаем */ } } };
    if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(runLift);
      var watched = document.querySelectorAll(BARS + ', #cookie-consent-banner');
      for (var w = 0; w < watched.length; w++) watchBox(watched[w]);
    }

    /* ⛔ ЗА АТРИБУТАМИ ВСЕГО ДОКУМЕНТА БОЛЬШЕ НЕ СЛЕДИМ — И ЭТО ЗАМЕР.

       Здесь стояло `attributes: true, attributeFilter: ['class','style']` по
       ВСЕМУ поддереву body. Задумано это было ради одного случая: панель лежит
       в DOM с начала и лишь ПОКАЗЫВАЕТСЯ сменой класса. Но следить пришлось за
       каждым классом и каждым стилем на странице — а их меняет весь остальной
       код: галерея переставляет метку `active` на 21 миниатюре, наблюдатели
       карточки переключают классы при прокрутке, и, главное, сам пересчёт писал
       свои переменные и будил себя же.
       Замер 24.08.2026 (замедление x4): 2,5 секунды покоя = 386 пересчётов.
       Тот единственный случай, ради которого это заводилось, надёжнее ловится
       наблюдателем за КОРОБКОЙ: показ панели — это `display:none → flex`, то
       есть размер 0x0 → настоящий, и ResizeObserver видит его независимо от
       того, класс это, стиль или что-то третье (проверено в разборе ниже).
       Здесь остаётся только появление НОВЫХ узлов — чтобы отдать их коробочному
       наблюдателю, если панель или планка приедут позже. */
    if (typeof MutationObserver === 'function' && document.body) {
      new MutationObserver(function (records) {
        var fresh = false;
        for (var m = 0; m < records.length; m++) {
          var added = records[m].addedNodes;
          for (var a = 0; a < added.length; a++) {
            var el = added[a];
            if (!el || el.nodeType !== 1) continue;
            fresh = true;
            if (typeof el.matches === 'function' && el.matches(BARS + ', #cookie-consent-banner')) watchBox(el);
            if (typeof el.querySelectorAll === 'function') {
              var inner = el.querySelectorAll(BARS + ', #cookie-consent-banner');
              for (var q = 0; q < inner.length; q++) watchBox(inner[q]);
            }
          }
        }
        if (fresh) runLift();
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* ⛔ НАБЛЮДАЕМ ЗА САМОЙ КОРОБКОЙ, А НЕ ЗА ПОВОДАМИ ЕЁ ИЗМЕНИТЬ. Это ЗАМЕР,
       а не перестраховка, и он поймал ошибку, которую пережил и черновик.

       Замер 1440x900, одна мгновенная прокрутка на 2000 точек:
            панель  y 831...900
            планка  y 842...884   — ВНУТРИ панели
            --ckb-lift            — ПУСТО, подъём не посчитан
            семь точек по панели  — ТРИ попадания в планку
       Почему: на компьютере панель показывается не сразу, а когда карточка сделки
       уходит из вида — это решает IntersectionObserver в js/flat.js. Мгновенный
       прыжок даёт РОВНО ОДНО событие прокрутки, и приходит оно РАНЬШЕ, чем панели
       добавят класс. Больше прокрутки нет — пересчитывать некому. При обычной
       прокрутке колесом событий десятки, и следующее же всё чинит: поэтому беда
       видна только на резком прыжке (клавиша End, бросок ползунка) и легко
       принимается за «показалось».

       Событийный список чинить бесполезно: поводов у чужого кода может быть
       сколько угодно. Меряем мы КОРОБКУ панели — за ней и следим. Переход
       display:none → flex меняет размер с 0x0 на настоящий, и ResizeObserver
       срабатывает независимо от того, что именно этот переход вызвало.
       Проверено на стенде: три попадания в планку → ноль.
       ⛔ 24.08.2026 наблюдатель за коробками ПЕРЕЕХАЛ ВЫШЕ — он теперь заводится
          первым, потому что наблюдатель за появлением узлов отдаёт ему новые
          панели. Сам механизм не изменился. */
    document.addEventListener('DOMContentLoaded', runLift);
    window.addEventListener('load', runLift);
  })();

  init();
})();
